/*
 * Where this build points, read from the document rather than compiled in.
 *
 * scripts/base/set-api-base-url.sh rewrites these attributes at DEPLOY time, so one artefact serves every
 * environment and switching the mock for the real API is a `terraform apply` rather than a rebuild. The
 * support site carries `data-api-base-url` for the same reason.
 *
 * An ABSENT value throws at startup instead of defaulting. A plausible fallback here would mean a deploy
 * that failed to rewrite produced a site calling localhost — which the browser blocks as mixed content,
 * with no failed request in the network tab and a page that simply never loads. That exact failure is
 * why the rewriting script has a guard of its own; this is the same guard from the other end.
 */
const read = (name: string): string => {
  const value = document.documentElement.getAttribute(name)
  if (!value) {
    throw new Error(
      `${name} is empty — the deploy did not rewrite it. See scripts/base/set-api-base-url.sh.`,
    )
  }
  return value.replace(/\/+$/, '')
}

export type Config = {
  /** api.account.birdjournal.com — credentials, profile, consent, deletion, referral. */
  accountApi: string
  /** api.billing.birdjournal.com — subscription, card, checkout. A different bounded context. */
  billingApi: string
  /** The Website: where the referral link points and the signed-in account area still lives. `www` in
   * live; the testing Website has no vanity hostname of its own. */
  marketing: string
  buildId: string
}

let cached: Config | undefined

export const config = (): Config => {
  cached ??= {
    accountApi: read('data-account-api-base-url'),
    billingApi: read('data-billing-api-base-url'),
    marketing: read('data-marketing-base-url'),
    buildId: document.documentElement.getAttribute('data-build-id') || 'unknown',
  }
  return cached
}
